import { apiFetch } from './client';
function buildSummaryParams(params) {
    const sp = new URLSearchParams();
    sp.set('from', params.from);
    sp.set('to', params.to);
    if (params.source)
        sp.set('source', params.source);
    if (params.groupBy)
        sp.set('groupBy', params.groupBy);
    if (params.bucket)
        sp.set('bucket', params.bucket);
    if (params.clinicId)
        sp.set('clinicId', params.clinicId);
    if (params.modality)
        sp.set('modality', params.modality);
    if (params.radiologistId)
        sp.set('radiologistId', params.radiologistId);
    if (params.urgency)
        sp.set('urgency', params.urgency);
    return sp;
}
export async function getAnalyticsSummary(params) {
    const sp = buildSummaryParams(params);
    sp.set('format', 'json');
    return apiFetch(`/analytics/summary?${sp.toString()}`);
}
/** Build the relative URL used to download the breakdown as CSV. */
export function analyticsSummaryCsvPath(params) {
    const sp = buildSummaryParams(params);
    sp.set('format', 'csv');
    return `/analytics/summary?${sp.toString()}`;
}
export async function getAnalyticsFilters() {
    return apiFetch('/analytics/filters');
}
